import React from 'react';
import AscModal from "../../containers/Elements/Modal/Modal";
import AscComponent from "../AscComponent";
import { Panel } from "react-bootstrap";
import InlineForm from "../../containers/Elements/FromGroup/InlineForm";
import AscAudio from "../../containers/Elements/Audio/Audio";

export default class AscConfirm extends AscComponent{
    constructor (props) {
        super(props);

        switch (this.props.state.modalType) {
            case "insert":
            case "create":
            case "insertBatch":
            case "csvInsert":
                this.confirmAction = this.props.langText.Body.ConfirmValueInsert;
                break;
            case "copy":
                this.confirmAction = this.props.langText.Body.ConfirmValueCopy;
                break;
            case "update":
                this.confirmAction = this.props.langText.Body.ConfirmValueUpdate;
                break;
            case "setting":
                this.confirmAction = this.props.langText.Body.ConfirmValueSetting;
                break;
            case "delete":
                this.confirmAction = this.props.langText.Body.ConfirmValueDelete;
                break;
            default:
                break;
        }
    }

    validationHandle = (param) => {
        let nowState = null;
        let {state} = this.props;
        const confirmMemoKey = this.props.confirmMemoKey || 'confirmMemo';
        const confirmValueKey = this.props.confirmValueKey || 'confirmValue';
        const confirmMemo = state ? state[confirmMemoKey] : null;
        const confirmValue = state ? state[confirmValueKey] : null;

        const requireConfirmMemo = !this.props.hideConfirmMemo;

        switch (param) {
            case confirmMemoKey:
                nowState = state[param]
                    ? null
                    : "error"
                ;
                break;
            case confirmValueKey:
                nowState = state[param] && state[param] === this.confirmAction
                    ? null
                    : "error"
                ;
                break;
            case "insert":
            case "create":
            case "insertBatch":
            case "csvInsert":
            case "copy":
            case "update":
            case "setting":
            case "delete":
                nowState =
                    (!requireConfirmMemo || confirmMemo)
                    && (confirmValue && confirmValue === this.confirmAction)
                ;
                break;
            default:
                break;
        }

        return nowState;
    }

    
    getConfirmItem = () => {

        let {
            state,
            langText,
            onTextChange_Limit,
            charaLimit,
            sprintf
        } = this.props;

        const confirmMemoKey = this.props.confirmMemoKey || 'confirmMemo';
        const confirmValueKey = this.props.confirmValueKey || 'confirmValue';

        let itemArr = [];

        if (this.props.headerMessage) {
            itemArr.push(
                <React.Fragment key="confirm-messages">
                    <p style={{ whiteSpace: 'pre-wrap' }}>{this.props.headerMessage}</p>
                    <br />
                </React.Fragment>
            );
        } else {
            // 一括登録の場合（発信規制のinsertBatch、顧客管理のcsvInsert等）または顧客管理画面のすべての操作
            if (this.props.state.modalType === "insertBatch" || 
                this.props.state.modalType === "csvInsert" ||
                this.props.confirmKey === this.props.langText.Body.CustomerInfo) {
                itemArr.push(
                    <React.Fragment key="confirm-messages">
                        <p>{sprintf(langText.Body.ConfirmActionBatchMessage, this.props.confirmKey, this.confirmAction)}</p>
                        <br />
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead>
                                <tr>
                                    {/* 2次元配列の場合：1行目（ヘッダー）の各列を表示 */}
                                    {Array.isArray(this.props.confirmKeyItem) && Array.isArray(this.props.confirmKeyItem[0])
                                        ? this.props.confirmKeyItem[0].map((headerItem, colIndex) => (
                                            <th key={colIndex} style={{ border: "1px solid #ddd", padding: "4px", background: "#f9f9f9", whiteSpace: "nowrap", fontSize: "13px" }}>
                                                {headerItem}
                                            </th>
                                        ))
                                        : (
                                            <th style={{ border: "1px solid #ddd", padding: "8px", background: "#f9f9f9", whiteSpace: "nowrap", fontSize: "14px" }}>
                                                {Array.isArray(this.props.confirmKeyItem) ? this.props.confirmKeyItem[0] : this.props.confirmKeyItem}
                                            </th>
                                        )
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(this.props.confirmKeyItem)
                                    ? this.props.confirmKeyItem.slice(1).map((item, rowIndex) => (
                                        <tr key={rowIndex}>
                                            {/* 2次元配列の場合：各行の各列を表示 */}
                                            {Array.isArray(item)
                                                ? item.map((cellItem, colIndex) => (
                                                    <td key={colIndex} style={{ border: "1px solid #ddd", padding: "4px", fontSize: "12px", wordBreak: "break-all" }}>
                                                        {cellItem}
                                                    </td>
                                                ))
                                                : (
                                                    <td colSpan={Array.isArray(this.props.confirmKeyItem[0]) ? this.props.confirmKeyItem[0].length : 1} 
                                                        style={{ border: "1px solid #ddd", padding: "8px", fontSize: "14px"}}>
                                                        {item}
                                                    </td>
                                                )
                                            }
                                        </tr>
                                    ))
                                    : (
                                        <tr>
                                            <td style={{ border: "1px solid #ddd", padding: "8px", fontSize: "14px" }}>
                                                {this.props.confirmKeyItem}
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                        <br />
                        <p>{sprintf(langText.Body.ConfirmInputDescription, this.confirmAction, this.confirmAction)}</p>
                        <br />
                    </React.Fragment>
                )
            } else {
                itemArr.push(
                    <React.Fragment key="confirm-messages">
                        <p>{sprintf(langText.Body.ConfirmActionMessage, this.props.confirmKey, this.props.confirmKeyItem, this.confirmAction)}</p>
                        <br></br>
                        <p>{sprintf(langText.Body.ConfirmInputDescription, this.confirmAction, this.confirmAction)}</p>
                        <br></br>
                    </React.Fragment>
                )
            }
        }

        // 音声再生バーの表示（audioURLが提供されている場合）
        if (this.props.audioURL && this.props.audioURL !== "") {
            itemArr.push(
                <div key="audio-player" style={{ margin: "20px 0" }}>
                    <label style={{ display: "block", marginBottom: "10px", fontWeight: "bold" }}>
                        {langText.Body.Audio}
                    </label>
                    <audio
                        controls
                        style={{ width: "100%" }}
                        controlsList="nodownload"
                    >
                        <source src={this.props.audioURL + ".ogg"} type="audio/ogg" />
                        <source src={this.props.audioURL + ".m4a"} type="audio/mp4" />
                        <source src={this.props.audioURL + ".mp3"} type="audio/mp3" />
                        <source src={this.props.audioURL + ".wav"} type="audio/wav" />
                        <source src={this.props.audioURL} type="audio/mp4" />
                        {langText.Message?.Format_Not_Support}
                    </audio>
                </div>
            );
        }

        if (!this.props.hideConfirmMemo) {
            itemArr.push(
                <InlineForm
                    key="confirm-memo"
                    controlId="confirm-memo"
                    label={langText.Body.ConfirmMemo}
                    value={state[confirmMemoKey]}
                    onChange={e => onTextChange_Limit(e, confirmMemoKey, charaLimit.Confirm_Memo)}
                    validationState = {this.validationHandle(confirmMemoKey)}
                />
            )
        }

        itemArr.push(
            <InlineForm
                label = {this.props.langText.Body.ConfirmValueField}
                key = "confirm-value"
                controlId = "confirm-value"
                type = "text"
                value = {state[confirmValueKey]}
                onChange = {e => onTextChange_Limit(e, confirmValueKey, charaLimit.Confirm_Value)}
                validationState = {this.validationHandle(confirmValueKey)}
            />
        );

        return itemArr;
    }

    render() {
        const showStateKey = this.props.showStateKey || 'showConfirm';
        return(
            <AscModal
                state = {this.props.state}
                propSetState = {(nextState) => {
                    // showがsetStateされた場合、showStateKeyで指定されたキーを更新(デフォルトはshowConfirm)
                    if (nextState && Object.prototype.hasOwnProperty.call(nextState, 'show')) {
                        this.props.propSetState({ [showStateKey]: nextState.show });
                    } else {
                        this.props.propSetState(nextState);
                    }
                }}
                langText = {this.props.langText}
                validationHandle = {this.validationHandle}
                onClick = {this.props.onClick}
                onClickCancelLockingBtn = {this.props.onClickCancelLockingBtn}
                customFunc = {this.props.customFunc}
                confirmKey = {this.props.confirmKey}
                confirmKeyItem = {this.props.confirmKeyItem}
                sprintf = {this.props.sprintf}
                titleOverride = {this.props.titleOverride}
                customBtn1Func = {e => this.props.customBtn1Func(e, false)}
                customBtn1Msg = {this.props.langText.Body.Cancel}
                customBtn1Class = "cancel-execute"
            >
                <Panel bsStyle="info">
                    <Panel.Body>
                        {this.getConfirmItem()}
                    </Panel.Body>
                </Panel>
            </AscModal>
        );
    }
}